import { render, staticRenderFns } from "./PendidikanTable.vue?vue&type=template&id=0abea4c1&"
import script from "./PendidikanTable.vue?vue&type=script&lang=js&"
export * from "./PendidikanTable.vue?vue&type=script&lang=js&"
import style0 from "./PendidikanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports